"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SvgIcon = {
  name: "SvgIcon",
  props: ["className", "iconName"],
  data: function data() {
    return {};
  },
  render: function render(h) {
    var className = this.className,
        iconName = this.iconName;
    var icoName = "#".concat(iconName);
    return h("svg", {
      "attrs": {
        "aria-hidden": "true"
      },
      "class": className ? className : "icon"
    }, [this.setUse(h, icoName)]);
  },
  methods: {
    setUse: function setUse(h, name) {
      return h("use", {
        attrs: {
          "xlink:href": name
        }
      });
    }
  }
};

SvgIcon.install = function (Vue) {
  Vue.component(SvgIcon.name, SvgIcon);
};

var _default = SvgIcon;
exports.default = _default;